const WIDE_GLYPH_PATTERN =
  /[\u1100-\u11FF\u2E80-\uA4CF\uAC00-\uD7A3\uF900-\uFAFF\uFE10-\uFE19\uFE30-\uFE6F\uFF00-\uFF60\uFFE0-\uFFE6]/;

const estimateLabelWidthPx = (label: string): number =>
  Array.from(label).reduce((total, char) => {
    if (char === ' ') {
      return total + 4;
    }
    return total + (WIDE_GLYPH_PATTERN.test(char) ? 12 : 7);
  }, 0);

interface FilterControlWidthOptions {
  minWidthPx?: number;
  maxWidthPx?: number;
  paddingPx?: number;
}

export const getFilterControlWidthPx = (
  labels: string[],
  { minWidthPx = 88, maxWidthPx = 240, paddingPx = 44 }: FilterControlWidthOptions = {}
): number => {
  const longestLabelWidth = labels.reduce((longest, label) => {
    return Math.max(longest, estimateLabelWidthPx(label));
  }, 0);

  return Math.min(Math.max(longestLabelWidth + paddingPx, minWidthPx), maxWidthPx);
};
